import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 38BFAB4E-F7D3-45AE-BD45-39385BB23EE2
 * name arrow-bottom-right-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightThinIcon = createSvgIcon(<><path d="M11.93 19L14.76 16.18L5 6.42L6.42 5L16.18 14.76L19 11.94V19Z" /></>, 'ArrowBottomRightThinIcon');
export default ArrowBottomRightThinIcon